/* tslint:disable */
/* eslint-disable */

import * as APITypes from "../models/API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getMetadata =
  /* GraphQL */ `query getMetadata($input: GetUsersByTeamIdInput!) {
    getTeams {
        id
        name
        custom_attributes
        __typename
    }
    getUsers {
        id
        user_name
        attributes
        __typename
    }
    getUsersByTeamId(input: $input) {
        id
        user_name
        __typename
    }
    getPendingUsersByTeamId(input: $input) {
        id
        user_name
        __typename
    }
    getTeamUserMapByTeamId(input: $input) {
        team_id
        user_id
        attributes
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetMetadataQueryVariables,
    APITypes.GetMetadataQuery
  >;
export const getTeamsWithPermissions =
  /* GraphQL */ `query GetTeamsWithPermissions($input: GetTeamsByUserNameInput!) {
  getTeamsWithPermissions(input: $input) {
    id
    name
    custom_attributes
    is_default
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetTeamsWithPermissionsQueryVariables,
    APITypes.GetTeamsWithPermissionsQuery
  >;
export const getUsersByTeamId =
  /* GraphQL */ `query GetUsersByTeamId($input: GetUsersByTeamIdInput!) {
  getUsersByTeamId(input: $input) {
    id
    user_name
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetUsersByTeamIdQueryVariables,
    APITypes.GetUsersByTeamIdQuery
  >;
export const getTeamByTeamId =
  /* GraphQL */ `query GetTeamByTeamId($input: GetTeamByTeamIdInput!) {
  getTeamByTeamId(input: $input) {
    id
    name
    custom_attributes
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetTeamByTeamIdQueryVariables,
    APITypes.GetTeamByTeamIdQuery
  >;
export const getHelpContent = /* GraphQL */ `query GetHelpContent {
  getHelpContent {
    content
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHelpContentQueryVariables,
  APITypes.GetHelpContentQuery
>;
export const getTeams = /* GraphQL */ `query getTeams {
    getTeams {
        id
        name
        custom_attributes
        __typename
    }
}
` as GeneratedQuery<APITypes.GetTeamsQueryVariables, APITypes.GetTeamsQuery>;
export const getDataSources =
  /* GraphQL */ `query getDataSources($input: GetDataSourcesInput!) {
    getDataSources(input: $input) {
        id
        team_id
        display_name
        description
        input_schema
        data_source_type
        created_at
        updated_at
        accessor_arn
        creator
        last_updated_by
        tool_id
        tool_name
        is_public
        is_global
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetDataSourcesQueryVariables,
    APITypes.GetDataSourcesQuery
  >;
export const getUserKnowledge =
  /* GraphQL */ `query getUserKnowledge($input: GetUserKnowledgeInput!) {
    getUserKnowledge(input: $input) {
        id
        team_id
        knowledge_name
        description
        knowledge_type
        content
        attributes
        is_public
        is_global
        created_at
        updated_at
        creator
        creator_id
        last_updated_by
        updated_by
        folder_id
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetUserKnowledgeQueryVariables,
    APITypes.GetUserKnowledgeQuery
  >;
// Metadata-only variant for team-wide reads (the Ask AI / WBR skill pickers
// and the sources tooltip). Deliberately does NOT select `content`: the
// resolver selects only the columns asked for, and a whole team's content in
// one response crossed the RDS Data API 1 MiB cap, which left the skill picker
// empty for that team. Use `getUserKnowledge` (with content) only for a
// folder, a single knowledge_id, or a limit/offset page.
export const getUserKnowledgeSummary =
  /* GraphQL */ `query getUserKnowledgeSummary($input: GetUserKnowledgeInput!) {
    getUserKnowledge(input: $input) {
        id
        knowledge_name
        description
        knowledge_type
        is_public
        is_global
        folder_id
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetUserKnowledgeQueryVariables,
    APITypes.GetUserKnowledgeSummaryQuery
  >;
export const getBRJobStatus =
  /* GraphQL */ `query getBRJobStatus($input: GetBRJobStatusInput!) {
    getBRJobStatus(input: $input) {
        job_id
        status
        created_at
        completed_at
        report_data
        error
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetBRJobStatusQueryVariables,
    APITypes.GetBRJobStatusQuery
  >;
export const getConversation =
  /* GraphQL */ `query getConversation($input: getConversationInput!) {
    getConversation(input: $input) {
        question_id
        conversation_id
        created_at
        user_id
        question
        response
        thinking
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetConversationQueryVariables,
    APITypes.GetConversationQuery
  >;
// Returns one row per conversation from the sparse conversation index, newest activity
// first, instead of every turn item. Deliberately does NOT select question/response:
// the previous shape pulled the full hex-encoded text of the user's entire history to
// render a list of titles, which is what pushed the response past DynamoDB's 1MB page
// limit and silently dropped conversations.
export const listConversations =
  /* GraphQL */ `query listConversations($input: listConversationsInput!) {
    listConversations(input: $input) {
        items {
            session_id
            conversation_id
            title
            created_at
            last_modified_at
            __typename
        }
        nextToken
        __typename
    }
}
` as GeneratedQuery<
    APITypes.ListConversationsQueryVariables,
    APITypes.ListConversationsQuery
  >;
export const getAppCall =
  /* GraphQL */ `query getAppCall($input: getAppCallInput!) {
    getAppCall(input: $input) {
        question_id
        call_id
        created_at
        app_id
        question
        response
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetAppCallQueryVariables,
    APITypes.GetAppCallQuery
  >;
export const getWBRCallouts =
  /* GraphQL */ `query getWBRCallouts($input: GetWBRCalloutsInput!) {
    getWBRCallouts(input: $input) {
        success
        message
        reports {
            filename
            showing_name
            source_pdf_url
            original_pdf_url
            callout_html_url
            highlighted
            highlighted_pdf_url
            highlighted_pdf_version
            margin_callouts
            margin_pdf_url
            margin_pdf_version
            margin_page_mapping
            cell_map_version
            __typename
        }
        callout_data
        callout_styles
        folder_summary_url
        merged_pdf_url
        merged_highlighted_pdf_url
        merged_margin_pdf_url
        margin_page_offset_map
        page_offset_map
        highlight_map
        skipped_files
        deep_dives
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetWBRCalloutsQueryVariables,
    APITypes.GetWBRCalloutsQuery
  >;

export const getWBRCalloutsCellMap =
  /* GraphQL */ `query getWBRCalloutsCellMap($input: GetWBRCalloutsInput!) {
    getWBRCallouts(input: $input) {
        success
        message
        reports {
            filename
            cell_map_version
            cell_reference_map
            cell_grid_mapping_key
            cell_grid_mapping_etag
            cell_grid_mapping_sha256
            source_pdf_etag
            __typename
        }
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetWBRCalloutsQueryVariables,
    APITypes.GetWBRCalloutsQuery
  >;

export const getWbrCalloutStatus =
  /* GraphQL */ `query getWbrCalloutStatus($input: WbrCalloutStatusInput!) {
    getWbrCalloutStatus(input: $input) {
        bucket
        statuses {
            file_name
            ready
            __typename
        }
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetWbrCalloutStatusQueryVariables,
    APITypes.GetWbrCalloutStatusQuery
  >;

export const getDashboardCache =
  /* GraphQL */ `query GetDashboardCache($input: GetDashboardCacheInput!) {
  getDashboardCache(input: $input) {
    pk
    sk
    dashboard_id
    report_data
    ai_summaries
    ttl
    created_at
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetDashboardCacheQueryVariables,
    APITypes.GetDashboardCacheQuery
  >;
export const getMarketplaces = /* GraphQL */ `query GetMarketplaces {
  getMarketplaces {
    marketplace_id
    country_code
    display_name
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMarketplacesQueryVariables,
  APITypes.GetMarketplacesQuery
>;
export const getRegions = /* GraphQL */ `query GetRegions {
  getRegions {
    region_code
    display_name
    marketplaces
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRegionsQueryVariables,
  APITypes.GetRegionsQuery
>;
export const getASFMPreProcessedData =
  /* GraphQL */ `query GetASFMPreProcessedData($input: ASFMPreProcessedDataInput!) {
  getASFMPreProcessedData(input: $input) {
    statusCode
    message
    data
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetASFMPreProcessedDataQueryVariables,
    APITypes.GetASFMPreProcessedDataQuery
  >;

export const asyncAthenaQuery =
  /* GraphQL */ `query AsyncAthenaQuery($input: AsyncAthenaQueryInput!) {
  asyncAthenaQuery(input: $input) {
    statusCode
    message
    data
    __typename
  }
}
` as GeneratedQuery<any, any>;

export const getManualCallouts =
  /* GraphQL */ `query getManualCallouts($input: GetManualCalloutsInput!) {
    getManualCallouts(input: $input) {
        id
        team_id
        week
        report_name
        page_num
        title
        status
        trend
        why_text
        creator_id
        creator_name
        updated_by
        updated_by_name
        created_at
        updated_at
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetManualCalloutsQueryVariables,
    APITypes.GetManualCalloutsQuery
  >;

export const getKnowledgeFolders =
  /* GraphQL */ `query getKnowledgeFolders($input: GetKnowledgeFoldersInput!) {
    getKnowledgeFolders(input: $input) {
        id
        folder_name
        team_id
        is_public
        is_global
        creator_id
        creator_name
        updated_by
        updated_by_name
        created_at
        updated_at
        item_count
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetKnowledgeFoldersQueryVariables,
    APITypes.GetKnowledgeFoldersQuery
  >;

export const getToolConfig =
  /* GraphQL */ `query getToolConfig($input: GetToolConfigInput!) {
    getToolConfig(input: $input) {
        id
        name
        description
        input_schema
        accessor_arn
        is_public
        tool_category
        tool_type
        user_id
        created_at
        updated_at
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetToolConfigQueryVariables,
    APITypes.GetToolConfigQuery
  >;

export const listTools =
  /* GraphQL */ `query listTools($input: ListToolsInput) {
    listTools(input: $input) {
        id
        name
        description
        input_schema
        accessor_arn
        is_public
        tool_category
        tool_type
        user_id
        created_at
        updated_at
        __typename
    }
}
` as GeneratedQuery<APITypes.ListToolsQueryVariables, APITypes.ListToolsQuery>;

// =============================================================
// Unified Callout queries (wbr-unified-callouts spec)
// =============================================================

export const getCallouts =
  /* GraphQL */ `query getCallouts($input: GetCalloutsInput!) {
    getCallouts(input: $input) {
        id
        team_id
        week
        report_name
        page_num
        source
        title
        status
        trend
        why_text
        impact
        card_number
        cell_refs {
            row
            col
            cell_map_version
            __typename
        }
        sparkline_data {
            values
            num_weeks
            label
            __typename
        }
        creator_id
        creator_name
        updated_by
        updated_by_name
        created_at
        updated_at
        ai_generation_batch_id
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetCalloutsQueryVariables,
    APITypes.GetCalloutsQuery
  >;

export const getCalloutSummary =
  /* GraphQL */ `query getCalloutSummary($input: GetCalloutSummaryInput!) {
    getCalloutSummary(input: $input) {
        team_id
        week
        report_name
        overview
        kpi_strip {
            label
            value
            sub
            color
        }
        key_callouts {
            page_num
            card_number
        }
        content
        creator_id
        creator_name
        updated_by
        updated_by_name
        created_at
        updated_at
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetCalloutSummaryQueryVariables,
    APITypes.GetCalloutSummaryQuery
  >;

export const getFeatureFlags = /* GraphQL */ `query getFeatureFlags {
    getFeatureFlags {
        name
        value
        __typename
    }
}
` as GeneratedQuery<
  APITypes.GetFeatureFlagsQueryVariables,
  APITypes.GetFeatureFlagsQuery
>;

// =============================================================
// Share link queries (share-link spec)
// =============================================================

export const getSharedSnapshot =
  /* GraphQL */ `query getSharedSnapshot($input: GetSharedSnapshotInput!) {
    getSharedSnapshot(input: $input) {
        share_token
        status
        turns {
            turn_seq
            question
            response
            thinking
            created_at
            __typename
        }
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetSharedSnapshotQueryVariables,
    APITypes.GetSharedSnapshotQuery
  >;

// =============================================================
// User Activity Audit Log query (user-activity-audit-log spec)
// =============================================================

export const getAuditLogs =
  /* GraphQL */ `query getAuditLogs($input: GetAuditLogsInput!) {
    getAuditLogs(input: $input) {
        records {
            record_id
            op_name
            op_type
            request_args
            response_payload
            user_id
            user_alias
            team_id
            team_name
            actor_source
            server_ts
            truncated
            channel
            __typename
        }
        next_token
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetAuditLogsQueryVariables,
    APITypes.GetAuditLogsQuery
  >;

// =============================================================
// Audit Usage Report query (audit-usage-report spec)
// =============================================================

export const getUsageReport =
  /* GraphQL */ `query getUsageReport($input: GetUsageReportInput) {
    getUsageReport(input: $input) {
        data_as_of
        entries {
            dimension_value
            operation_count
            __typename
        }
        daily_entries {
            day
            dimension_value
            operation_count
            __typename
        }
        daily_distinct_users {
            day
            distinct_users
            __typename
        }
        __typename
    }
}
` as GeneratedQuery<
    APITypes.GetUsageReportQueryVariables,
    APITypes.GetUsageReportQuery
  >;

export const getWeblabView =
  /* GraphQL */ `query GetWeblabView($input: WeblabViewInput!) {
  getWeblabView(input: $input) {
    statusCode
    message
    data
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetWeblabViewQueryVariables,
    APITypes.GetWeblabViewQuery
  >;
